import { Dialog, DialogContent } from '@mui/material'
import { PDFViewer } from '@react-pdf/renderer'
import PdfPontoDeVenda from '../../../../utils/pdfComponets/pdfPontoDeVenda'

const ModalImprime = ({ data, close }) => (
  <Dialog maxWidth="lg" fullWidth open onClose={() => close(null)}>
    <DialogContent>
      <PDFViewer width="100%" height="600px">
        <PdfPontoDeVenda {...data} />
      </PDFViewer>
    </DialogContent>
  </Dialog>
)

export default ModalImprime
